import React, { useContext } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AllStateContext from "../context/allstateContext";

const DeletedConfirmationDialog = ({ isDeleted }) => {
  const { openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog } =
    useContext(AllStateContext);

  const handleClose = () => {
    setOpenDeleteConfirmationDialog(false);
  };

  return (
    <div>
      <Dialog
        open={openDeleteConfirmationDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmation Required: Content Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please confirm if you want to delete the content. This action is
            final and cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button
            onClick={() => {
              isDeleted();
              setOpenDeleteConfirmationDialog(false);
            }}
            autoFocus
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeletedConfirmationDialog;
